<template>
    <div class="card m-3">
        <div class="card-header">Answer</div>
        <div class="card-body" style="text-align:left">
            <p class="card-text" v-html="format(answer)"/>
        </div>
    </div>
</template>
<script>
import MarkdownIt from "markdown-it";
export default {
    props: ['answer'],
    methods: {
        format(content) {
            if (!content) {
                return "";
            }
            const markdown = new MarkdownIt();
            // console.log(markdown.render(content));
            return markdown.render(content)
            // return content.split(/\r?\n/).map((x) => '<p>' + x + '</p>').join('\n');
        }
    },
}
</script>
<style scoped></style>